import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button } from '@/components/ui/Button';
import { useToast } from '@/hooks/useToast';
import * as seguimientosApi from '@/api/seguimientos.api';
import type { EtapaManual } from '@/api/seguimientos.api';

/**
 * LO QUE PASÓ FUERA DEL CHAT (tanda 3, P7). Richard marca que tuvo el Zoom o el tour
 * y el sistema le deja «caerle arriba» a las 24 h: «que si yo tuve una llamada … o
 * hicimos un Zoom … hay que caerle arriba full para que cierre» (audio-3). «Pedir
 * siguiente paso» deja un borrador, que él aprueba en Seguimientos.
 */
const BOTONES: { etapa: EtapaManual; etiqueta: string }[] = [
  { etapa: 'zoom_hecho', etiqueta: 'Tuve el Zoom' },
  { etapa: 'tour', etiqueta: 'Hicimos tour' },
  { etapa: 'siguiente_paso', etiqueta: 'Pedir siguiente paso' },
];
const LISTO: Record<EtapaManual, string> = {
  zoom_hecho: 'Anotado: mañana a esta hora te recuerdo caerle arriba.',
  tour: 'Anotado: mañana a esta hora te recuerdo caerle arriba.',
  siguiente_paso: 'Listo: el borrador está en Seguimientos para que lo apruebes.',
};

export function EtapaBotonesView({ ocupado, onElegir }: { ocupado: boolean; onElegir: (e: EtapaManual) => void }) {
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-2 border-b border-surface-border bg-white px-4 py-2 dark:border-slate-800 dark:bg-slate-900">
      {BOTONES.map((b) => (
        <Button key={b.etapa} variant="outline" size="sm" disabled={ocupado} onClick={() => onElegir(b.etapa)}>
          {b.etiqueta}
        </Button>
      ))}
    </div>
  );
}

export function EtapaBotones({ conversationId }: { conversationId: string }) {
  const qc = useQueryClient();
  const toast = useToast();
  const marcar = useMutation({
    mutationFn: (etapa: EtapaManual) => seguimientosApi.etapa(conversationId, etapa),
    onSuccess: (_r, etapa) => {
      toast.success(LISTO[etapa]);
      void qc.invalidateQueries({ queryKey: ['seguimientos'] });
    },
    onError: (e) => toast.error(e instanceof Error ? e.message : 'No se pudo guardar'),
  });
  return <EtapaBotonesView ocupado={marcar.isPending} onElegir={(e) => marcar.mutate(e)} />;
}
